import * as APIHelper from "services/api"
import * as endPoint from "shared/constants/endpoint"

class ReturnBusiness {
  getData = async searchParams => {
    const options = { params: searchParams }
    const response = (await APIHelper.getRequest(`${endPoint.returns.list}`, options)) || {}
    return (response?.resource || []).map((item, idx) => ({ ...item, key: idx }))
  }
}

export const returnBusiness = new ReturnBusiness()
